import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LINKS } from "../constants/links";
import LoginModal from './LoginModal';
import { isAuthenticated, logout } from '../api/auth';
import {WORDS} from "../constants/words";

function Navbar() {
    const [showModal, setShowModal] = useState(false);
    const [authenticated, setAuthenticated] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const checkAuth = () => {
            const authStatus = isAuthenticated();
            setAuthenticated(authStatus);
        };

        checkAuth();

        const handleStorageChange = () => {
            checkAuth();
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [showModal]);

    const handleLogin = () => {
        setShowModal(true);
    };

    const handleLogout = () => {
        logout();
        setAuthenticated(false);

        navigate('/');
    };

    const handleLoginSuccess = () => {
        setShowModal(false);
        setAuthenticated(true);
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg custom-navbar">
                <div className="container-md">
                    <Link className="navbar-brand" to="/">{WORDS.SITE_NAME}</Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarNav">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link" to="/">{WORDS.NAV_HOME}</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    id="projectsDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {WORDS.NAV_PROJECTS}
                                </a>
                                <ul className="dropdown-menu" aria-labelledby="projectsDropdown">
                                    <li>
                                        <Link className="dropdown-item" to={LINKS.LEARNING_CARDS_SERVICE}>
                                            {WORDS.LEARNING_CARDS_SERVICE}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul className="navbar-nav ms-auto">
                            {authenticated ? (
                                <li className="nav-item">
                                    <button
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={handleLogout}
                                    >
                                        Logout
                                    </button>
                                </li>
                            ) : (
                                <li className="nav-item">
                                    <button
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={handleLogin}
                                    >
                                        Login
                                    </button>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </nav>

            <LoginModal
                show={showModal}
                onClose={() => setShowModal(false)}
                onLoginSuccess={handleLoginSuccess}
            />
        </>
    );
}

export default Navbar;